var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoDoang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 389,
    height: 450,
    viewBox: "0 0 389 450",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.625 226.944V145.788H0V242.981L145 450H244L389 242.981V145.788H340.375V226.944L218.813 401.404H170.188L48.625 226.944Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.625 121.49H0V24.2981L24.3125 0H364.688L389 24.2981V121.49H340.375V72.8942L316.063 48.5961H72.9375L48.625 72.8942V121.49Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M170.188 121.49H72.9375V97.1922L97.25 72.8942H291.75L316.063 97.1922V121.49H218.813V358.639L206.17 377.106H182.83L170.188 358.639V121.49Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.25 121.49H72.9375V216.739L97.25 252.214L109.406 269.708V226.944L97.25 208.963V121.49Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M316.063 216.739L291.75 252.214L279.594 269.708V226.944L291.75 208.963V121.49H316.063V216.739Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDoang);
export default __webpack_public_path__ + "static/media/LogoDoang.4ec95e9ee43597f6d47349116f4123a4.svg";
export { ForwardRef as ReactComponent };